
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comercial/parcerias",
      function () {
        return require("private-next-pages/comercial/parcerias.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comercial/parcerias"])
      });
    }
  